import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdPerson,
  MdHome,
  MdLock,
  MdSupport,
  MdAssessment,
  MdBook,
  MdExplore,
  MdQuiz,
  MdAutoAwesome,
  MdBolt,
  MdAutoStories,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';
import RTL from 'views/admin/rtl';
import ProtectedRoute from 'utils/ProtectedRoutes';
import PublicRoute from 'utils/PublicRoute';
import Chat from 'views/admin/chat';
// Auth Imports
import SignInCentered from 'views/auth/signIn';
import SignUp from 'views/auth/signUp';
import ExploreSkills from 'views/admin/exploreSkills';
import MyLearning from 'views/admin/myLearning';
import SkillAssessment from 'views/admin/skillAssessment';
import Support from 'views/admin/support';
import Dashboard from 'views/admin/dashboard';
import HeadToHeadQuiz from 'views/admin/headToheadQuiz';
import ForgotPassword from 'views/auth/forgotPassword';
import ResetPassword from 'views/auth/resetPassword';
import MyCoach from 'views/admin/myCoach';
import Challenges from 'views/admin/challenges';
import PersonalCourses from 'views/admin/personalCourses';
import PersonalCourseLesson from 'views/admin/personalCourses/lesson';

const routes = [
  {
    name: 'Dashboard',
    nameKey: 'dashboard',
    layout: '/admin',
    path: '/index',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },

  {
    name: 'Explore Skills',
    nameKey: 'exploreSkills',
    layout: '/admin',
    path: '/explore-skills',
    icon: <Icon as={MdExplore} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <ExploreSkills />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },
  {
    name: 'My Learning',
    nameKey: 'myLearning',
    layout: '/admin',
    path: '/my-learning',
    icon: <Icon as={MdBook} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <MyLearning />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },
  {
    name: 'My Coach',
    nameKey: 'myCoach',
    layout: '/admin',
    path: '/my-coach',
    icon: <Icon as={MdAutoAwesome} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <MyCoach />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },
  {
    name: 'Challenges',
    nameKey: 'challenges',
    layout: '/admin',
    path: '/challenges',
    icon: <Icon as={MdBolt} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <Challenges />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },
  {
    name: 'Create Personal Course',
    nameKey: 'personalCourses',
    layout: '/admin',
    path: '/personal-courses',
    icon: <Icon as={MdAutoStories} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <PersonalCourses />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },
  {
    name: 'Personal Course Lesson',
    layout: '/admin',
    path: '/personal-courses/:courseId/lesson/:moduleId/:lessonId',
    icon: <Icon as={MdAutoStories} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <PersonalCourseLesson />
      </ProtectedRoute>
    ),
    showOnSidebar: false,
    rolesThatCanSee: ['user', 'admin']
  },
  {
    name: 'Skill Assessment',
    nameKey: 'skillAssessment',
    layout: '/admin',
    path: '/skill-assessment/:skillId?',
    sidebarPath: '/skill-assessment/',
    icon: <Icon as={MdAssessment} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <SkillAssessment />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },
  // {
  //   name: 'Support',
  //   layout: '/admin',
  //   path: '/support',
  //   icon: <Icon as={MdSupport} width="20px" height="20px" color="inherit" />,
  //   component: (
  //     <ProtectedRoute>
  //       <Support />
  //     </ProtectedRoute>
  //   ),
  //   showOnSidebar: true,
  //   rolesThatCanSee: ['user', 'admin']
  // },
  {
    name: 'H2H Quiz',
    nameKey: 'h2hQuiz',
    layout: '/admin',
    path: '/head-to-head-quiz',
    icon: <Icon as={MdQuiz} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <HeadToHeadQuiz />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },
  // {
  //   name: 'Data Tables',
  //   layout: '/admin',
  //   icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
  //   path: '/data-tables',
  //   component: (
  //     <ProtectedRoute>
  //       <DataTables />
  //     </ProtectedRoute>
  //   )
  // },
  {
    name: 'Profile',
    nameKey: 'profile',
    layout: '/admin',
    path: '/profile/:username?',
    sidebarPath: '/profile',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
    showOnSidebar: true,
    rolesThatCanSee: ['user', 'admin']
  },

  {
    name: 'Chat',
    layout: '/admin',
    path: '/chat/:skillId',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: (
      <ProtectedRoute>
        <Chat />
      </ProtectedRoute>
    ),
    showOnSidebar: false, // Hide from sidebar if not needed
    rolesThatCanSee: ['user', 'admin'],
  },

  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: (
      <PublicRoute>
        <SignInCentered />
      </PublicRoute>
    ),
    showOnSidebar: false
  },

  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: (
      <PublicRoute>
        <SignUp />
      </PublicRoute>
    ),
    showOnSidebar: false
  },
  {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: (
      <PublicRoute>
        <ForgotPassword />
      </PublicRoute>
    ),
    showOnSidebar: false
  },
  {
    name: 'Reset Password',
    layout: '/auth',
    path: '/reset-password',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: (
      <PublicRoute>
        <ResetPassword />
      </PublicRoute>
    ),
    showOnSidebar: false
  }
];

export default routes;
